import React, { useState } from 'react';
import { GetSelectedDriversForJob_getSelectedDriversForJob as SelectedDrivers } from '../../../types/schemaTypes';
import './SelectedDriverItem.scss';
import DeleteModal from '../../JobProfile/DeleteModal';
import '../../../components/_common/GridView/GridViewItem/GridViewItem.scss';
import TextContent from '../../_common/TextContent';
import { OverlayTrigger } from 'react-bootstrap';

interface CustomerParentItemProps {
    selectedDriver: SelectedDrivers;
    index: number;
    canEditDriversInDriverPool: boolean;
    onDelete?: (record: any) => void;
    onSaveDriverNotes: (selectedDriver: SelectedDrivers) => void;
}

const SelectedDriverItem = ({
    selectedDriver,
    index,
    onDelete,
    onSaveDriverNotes,
    canEditDriversInDriverPool,
}: CustomerParentItemProps): React.ReactElement => {
    const { name, companyName, notes } = selectedDriver;
    const isOdd = index % 2 == 1;
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const [disableNotes, setDisableNotes] = useState(false);
    const [driverNotes, setDriverNotes] = useState('');
    const [isNotesCleared, setIsNotesCleared] = useState(false);
    const containerStyle = `SelectedDriverItem-Bottom-Container row ${!isOdd &&
        'SelectedDriverItem-Bottom-Container-With-Background row'}`;

    const handleDelete = () => {
        onDelete && onDelete(selectedDriver.driverId);
        setDeleteConfirm(false);
    };

    const onChange = value => {
        setDriverNotes(value);
        setIsNotesCleared(true);
    };

    const onSave = (): void => {
        if (driverNotes || isNotesCleared) {
            const selectedDriverCopy = {...selectedDriver}
            selectedDriverCopy.notes = driverNotes;
            selectedDriver = {...selectedDriverCopy}
            onSaveDriverNotes(selectedDriver);
            setDriverNotes('');
            setIsNotesCleared(false);
        }
    };

    return (
        <div className={containerStyle}>
            <div className="SelectedDriverItem-List-Header col-md-3">{name}</div>
            <div className="SelectedDriverItem-List-Header col-md-3">{companyName}</div>
            <div className="SelectedDriverItem-List-Header col-md-3">
                {notes !== '' ? (
                    <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<div className="Notes-Tooltip">{notes}</div>}
                    >
                        <input
                            id="selectedDriversSearch"
                            type="text"
                            placeholder="Notes"
                            onBlur={() => setDisableNotes(true)}
                            onChange={e => onChange(e.target.value)}
                            className="Notes-Input"
                            defaultValue={notes ? notes : driverNotes}
                            autoComplete="off"
                            onFocus={() => setDisableNotes(false)}
                            maxLength={50}
                        />
                    </OverlayTrigger>
                ) : (
                    <input
                        id="selectedDriversSearch"
                        type="text"
                        placeholder="Notes"
                        onBlur={() => setDisableNotes(true)}
                        onChange={e => onChange(e.target.value)}
                        className="Notes-Input"
                        defaultValue={notes}
                        autoComplete="off"
                        onFocus={() => setDisableNotes(false)}
                        maxLength={50}
                    />
                )}
                {(notes || driverNotes) && (
                    <div className="GridViewItem-DriverList-Header">
                        {/* {canEditDriversInDriverPool && onDelete && (
                            <div onClick={() => setDisableNotes(false)} className={` ${'GridViewItem-Edit-Container'}`}>
                                <i className="material-icons CustomersItem-Icon">edit</i>
                            </div>
                        )}
                        &nbsp;|&nbsp; */}
                        {canEditDriversInDriverPool && onDelete && (
                            <div onClick={onSave} className={` ${'GridViewItem-Edit-Container'}`}>
                                <i className="material-icons SaveNotes-Icon">check</i>
                            </div>
                        )}
                    </div>
                )}
            </div>
            {canEditDriversInDriverPool && (
                <div className="GridViewItem-List-Header col-md-3">
                    {canEditDriversInDriverPool && onDelete && (
                        <div onClick={() => setDeleteConfirm(true)} className={` ${'GridViewItem-Edit-Container'}`}>
                            <i className="material-icons UsersItem-Icon">delete</i>
                            <span className="UsersItem-Link">Remove Driver</span>
                        </div>
                    )}
                </div>
            )}
            <DeleteModal
                show={deleteConfirm}
                name={'driver from pool'}
                onConfirm={handleDelete}
                onCancel={() => setDeleteConfirm(false)}
            />
        </div>
    );
};

export default SelectedDriverItem;

